import React from "react";

export default function Glossary() {
  return (
    <div className="box">
      <h5 className="text-xl text-center p-2 text-orange-primary underline">
        Inmate Search Detail Report &mdash; Glossary
      </h5>
      <div style={{ padding: "20px 40px" }}>
        <p style={{ textAlign: "justify" }}>
          <b>SCDC ID</b> &mdash; Inmate number assigned by SCDC.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>SID</b> &mdash; Identification number assigned by South Carolina
          law enforcement.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>Citizenship</b> &mdash; Inmate reported and unconfirmed.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>Build</b> &mdash; Entered by SCDC staff at time of admission; not
          always updated subsequent to changing physical appearance.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>Complexion</b> &mdash; Entered by SCDC staff at time of admission;
          not always updated subsequent to changing physical appearance.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>Hair Color</b> &mdash; Entered by SCDC staff at time of admission;
          not always updated subsequent to changing physical appearance.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>Eye Color</b> &mdash; Entered by SCDC staff at time of admission;
          not always updated subsequent to changing physical appearance.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>Picture Date</b> &mdash; Most recent frontal mug shot with the date
          the photo was taken.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>Offender Type</b> &mdash; The type of sentence being served by the
          inmate affects release and parole eligibility. Most inmates are
          sentenced to 'straight time' (i.e., determinate) sentences, although
          exceptions include 'youthful offender' (indeterminate sentence
          length), 'shock incarceration' (90 day service requirement), and
          'juvenile' (released upon their 21st birthday).
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>Admission Date</b> &mdash; Date of most recent admission to SCDC.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>Location</b> &mdash; SCDC institution, county designated facility,
          or county of authorized absence.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>Projected Release Date</b> &mdash; Date when SCDC projects the
          inmate will satisfy all incarcerated terms based upon the type of
          sentence being served and assuming the inmate continues to earn work,
          educational and good time credits at the present rate. The projected
          release date or 'maxout' date is subject to change (e.g., rules
          violations can result in loss of good time and later projected release
          date).
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>Projected Parole Eligibility</b> &mdash; Date the inmate will
          become eligible for parole or, in some cases, date when a parole
          hearing is scheduled. NOTE: parole eligibility/hearing for 'straight
          time' inmates is determined by the South Carolina Department of
          Probation, Parole, and Pardons; youthful offender parole eligibility
          is determined by SCDC based upon inmate participation in specialized
          treatment programs. Projected parole eligibility is subject to change
          based upon inmate behavior.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>Supervised Furlough Eligibility</b> &mdash; By Statute, some
          inmates depending upon offense and offense date, are eligible for
          early release to supervised furlough.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>Sentence Length</b> &mdash; The total amount of time to serve in
          the SCDC. Suspended sentences and terms of probation are not included
          in the sentence length. Inmates with life sentences are indicated as
          'life' and death sentences indicated as 'death'. Inmates sentenced as
          Youthful offenders serve indeterminate terms up to 6 years.
        </p>
        <br />
        <h5 className="text-xl text-center p-2 text-orange-primary underline">
          SCDC DISCIPLINARY OFFENSES
        </h5>
        <br />
        <b>1. RULES VIOLATION DEFINED: </b>
        The following disciplinary offenses represent violations of the SCDC
        inmate rules. A violation of these rules may consist of any of the
        following:
        <ul style={{ marginLeft: "40px" }}>
          <li>Engaging in the specified behavior;</li>
          <li>Attempting to engage in the specified behavior;</li>
          <li>Conspiring to engage in the specified behavior; or</li>
          <li>
            Aiding others in engaging, attempting to engage, or conspiring to
            engage in the specified behavior.&nbsp;
          </li>
        </ul>
        <b>2. LIST OF OFFENSES: </b>The following is a list of the titles and
        code numbers of disciplinary offenses.&nbsp;
        <br />
        <h5 className="text-xl text-center p-2 text-orange-primary underline">
          Level 1 Offenses
        </h5>
        <br />
        <p style={{ textAlign: "justify" }}>
          <b>
            801&nbsp; Assault and/or Battery of an SCDC Employee or other
            Government Employee, Contract Employee, Volunteer, or Member of the
            Public with Means/and/or Intent to Kill or Injure:&nbsp;
          </b>{" "}
          The willful hitting, striking, or unauthorized touching of an SCDC
          employee or other government agency employee, contract employee,
          volunteer, or member of the public with or without a weapon or the
          throwing of any substance at or on an SCDC employee or other
          government agency employee or contract employee who is exercising
          legitimate authority over an inmate, when such hitting, striking,
          throwing, or unauthorized touching causes bodily injury.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>802&nbsp; Sexual Assault:&nbsp;</b>Forcing another person, by
          violence or threats of violence, to perform a sexual act. (A sexual
          act is any intentional contact between the genitals of one inmate and
          the genitals, mouth, anus, or hands of another person.) A conviction
          for this charge will result in a loss of the inmate's visitation
          privileges for one (1) year regardless of where the infraction
          occurred.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>803&nbsp; Riot</b>:&nbsp; When an inmate, with two or more persons,
          intentionally participates in conduct that creates danger of damage or
          injury to property or persons and substantially obstructs the
          performance of unit operations or institutional operations.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>804&nbsp; Homicide:</b>&nbsp; The killing of any person
          with/without malice, advance thought, either expressed or implied.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>805&nbsp; Hostage Taking:&nbsp; </b>The act of any inmate acting
          alone or with others who by threats, coercion, intimidation, or
          physical force, takes, holds, or carries away any person as a hostage
          for any reason whatsoever.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>806&nbsp;</b> Any Act Defined as a Felony by the Laws of the State
          of South Carolina or the United States and not otherwise Defined in
          these Rules.(State Criminal Statute must be provided.)
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            857&nbsp;Assault and/or Battery of an Inmate with Means and/or
            Intent to Kill or Injure:
          </b>{" "}
          The willful hitting, striking, throwing of substances, or unauthorized
          touching of an inmate with or without a weapon by another inmate, when
          such hitting, striking, throwing, or unauthorized touching results in
          great bodily injury.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>896&nbsp;</b>
          <b>
            Unauthorized wearing, possession and/or providing Agency uniform(s):{" "}
          </b>
          The wearing, possession and or providing of an Agency uniform is a
          serious offense as it relates to inmate identification, institutional
          order and security.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>897 </b>
          <b>Possession of Security Equipment/Property: </b>The unauthorized
          possession and or use of security equipment/property of SCDC or that
          of an outside source. Unauthorized items may include, but not be
          limited to, institutional security keys, restraints, chemical
          munitions, employee ID cards, crafted devices, i.e., hand cuff keys,
          institution keys, or dummy like objects, (for escape/attempt escape
          purposes),etc. This offense also includes the possession of any
          materials and/or drawings that could be used in the creation of
          institution keys.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>898 </b>
          <b>The Possession of Any Communication Device:</b> The possession
          <b>,</b> receipt, use, concealment, storage, purchase, sale or
          facilitation of cellular phones or other communications equipment
          and/or any components thereof. This includes, but is not limited to,
          MP3 players, I-pods, e-readers or any like devices.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>901&nbsp; Class I Escape:</b> Any escape, attempted escape, or
          aiding/abetting escape from a Level 2 or 3 Institution or from medium
          or maximum custody at a local detention center. Also includes escape
          from a Level 1 Institution or minimum custody at a local detention
          center that involves any threat of violence, physical harm, or other
          aggravating circumstances. <b>NOTE:</b> Should an inmate assigned to
          an outside detail at any level institution, walk-off (with no
          aggravating circumstances), should be classified as a Class II escape.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>902&nbsp; Class II Escape:</b> Any escape, attempted escape, or
          aiding, abetting escape from a Level 1 Institution or minimum custody
          at a local detention center that does not involve any threat of
          violence, physical harm, or aggravating circumstances.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            903&nbsp;The Trafficking, Use, and/or Possession of Narcotics,
            Marijuana, or Unauthorized Drugs, including prescription drugs, or
            Inhalants.
          </b>{" "}
          The actual or constructive trafficking, use or possession of drugs of
          any description (except those prescribed by an authorized physician
          and within authorized amounts, expiration date, e.g. barbiturates,
          narcotics, medicines, marijuana and poisons, as well as all drug
          paraphernalia, such as needles, syringes, etc. Any inmate testing
          positive for any unauthorized drug, refusing to submit to a drug test,
          or failing to produce a specimen within three (3) hours, as specified
          in SCDC Policy GA-03.03, "Inmate Drug Testing/Screening Program." This
          rules violation encompasses the "hoarding" of prescribed medication by
          any inmate(s), or inmates who having accepted their medication, then
          failed to ingest the medication at the time they are issued it at the
          pill call. Any inmate acting under the influence of any inhalant other
          than one prescribed by an authorized physician which when inhaled,
          creates an altered state of physical or mental activity. Sight and
          smell identification may be used to identify any drug where no
          available scientific tests have been created and/or confirmed
          credible.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>904&nbsp; Possession of Escape Tools and/or Paraphernalia: </b>The
          actual or constructive possession of any tool, device, document,
          drawing, or any other item that could be used to plan or execute an
          escape from a correctional institution.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            905&nbsp; Creating and/or Assisting With A Social Networking Site:
          </b>{" "}
          The facilitation, conspiracy, aiding, abetting in the creation or
          updating of an internet web site or social networking site.
        </p>
        <br />
        <h5 className="text-xl text-center p-2 text-orange-primary underline">
          Level 2 Offenses{" "}
        </h5>
        <br />
        <p style={{ textAlign: "justify" }}>
          <b>
            807&nbsp; Striking an SCDC Employee or other Government Employee,
            Contract Employee, Volunteer, or Member of the Public:{" "}
          </b>
          The willful hitting, striking, or unauthorized touching of an SCDC
          employee or other government agency employee, contract employee,
          volunteer, or member of the public with or without a weapon or the
          throwing of any substance at or on an SCDC employee, other government
          agency employee, contract employee, or volunteer who is exercising
          legitimate authority over an inmate, when such hitting, striking,
          throwing, or unauthorized touching does not cause bodily injury.&nbsp;
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>808&nbsp; Fighting With a Weapon: </b>
          Any group of two or more inmates who engage in a physical altercation
          with any instrument used for the purpose of inflicting physical injury
          on another person.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            809&nbsp; Threatening to Inflict Harm on/Assaulting&nbsp; an
            Employee and/or Members of the Public:{" "}
          </b>
          Communication, verbal or written, by an inmate to an individual that
          s/he intends to injure that person or commit a violent or unlawful act
          dangerous to human life, presently or in the future; or one who
          commits a physical act of a threatening nature, and the probable
          result of such threats or action is to place the individual in fear of
          bodily injury; or one who causes evacuation&nbsp;of a building; or one
          who creates serious disruption or alarm. Any unauthorized body contact
          of an employee or member of the public which creates serious alarm,
          but does not result in bodily injury.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>810&nbsp; Striking an Inmate With or Without a Weapon:</b> The
          willful hitting, striking, throwing of any substance at, or
          unauthorized touching of one inmate by another inmate with or without
          a weapon, whether or not such hitting, striking, or unauthorized
          touching causes bodily injury.&nbsp;&nbsp;
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>811&nbsp; Possession of a Weapon: </b>
          The actual or constructive possession by an inmate of any instrument
          intended to be used to inflict physical injury on any person.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>812&nbsp; Robbery with Force: </b> The taking of property of
          another person in that person's presence with use of force and
          violence which places that person in fear of his/her safety by the use
          of such force, violence, or threats.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            813&nbsp; Throwing of any Substance or Object on an SCDC Employee or
            other Government Employee, Contract Employee, or Volunteer:{" "}
          </b>
          The throwing of any substance at or on an SCDC employee or other
          government agency employee, contract employee, or volunteer who is
          exercising legitimate authority over an inmate, whether or not such
          throwing causes bodily injury.&nbsp;
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>814&nbsp; Inciting/Creating a Disturbance:</b>
          Any act or activity which results in a disruption of institutional
          operations or a breach of institution security. Any inmate who
          purposefully incites or urges a group of two or more other inmates to
          engage in a current or impending disturbance of institutional
          operations or gives commands, directions, instructions, or signals to
          a group of two or more persons to cause, continue, or enlarge a
          disturbance. An inmate may be found guilty of this violation even
          where no disruption of institutional operations actually occurs as a
          direct or indirect result of his/her actions. A disturbance as used
          herein is an assemblage of three or more persons which creates grave
          danger or damage or injury to property or persons and/or substantially
          disrupts the normal functioning of the institution.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            820&nbsp; Damage, Loss, Destruction, or Defacing of Property Valued
            at 100.00 or more:
          </b>{" "}
          The intentional or reckless damaging, destroying, or disfiguring
          property belonging to a government agency, a private citizen, an
          employee, or another inmate.&nbsp;Possession of damaged, destroyed, or
          disfigured property and the negligent loss of property also qualify as
          a violation of this offense. (NOTE: This does not include cases in
          which an inmate loses his/her ID Card or issued room key. In these
          cases, the inmate will be required to pay a replacement fee for such
          items and will not be processed pursuant to these procedures. See
          also, SCDC Policies/Procedures OP-21.06, &quot;Inmate Identification
          Cards,&quot; and OP-22.17, &quot;Key Control,&quot; for information
          regarding the processing of replacement fees.)&nbsp; This charge must
          be forwarded to a Disciplinary Hearing.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>822&nbsp; Sexual Misconduct: </b> (1) Engaging in sexual acts or
          intimate physical contact of a sexual nature with others; or
          soliciting sexual acts from others.&quot;&nbsp; A conviction for this
          charge will result in a loss of the inmate's visitation privileges for
          360 days regardless of where the infraction occurred.&nbsp; This
          charge must be forwarded to a Disciplinary Hearing. NOTE: The
          conviction of 822 does not require the wearing of pink jumpsuits with
          the exception noted in section 17.8.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            832&nbsp; Unauthorized Inmate Organization Activity or Participation
            in a Security Threat Group (STG) or STG Activity:
          </b>{" "}
          &nbsp; Any participation of any inmate in any organization which has
          not been approved or any informal organization, association, or group
          of three (3) or more inmates that has a common name, and whose members
          or associates engage or have engaged in activities that include
          planning, organizing, threatening, soliciting, or committing unlawful
          acts of misconduct classified as serious threats or potential threats
          to the safety and security of the public, the Department, employees,
          visitors, and/or other inmates, or any other group that has been
          designated a Security Threat Group by the Agency Director. Possession
          of STG material is sufficient to warrant this charge. (Sentence in
          BLUE, added by Change 1, dated April 23, 2013.)
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>854 Exhibitionism and Public Masturbation:</b> (1) Engaging in acts
          of indecent and/or unnecessary exposure of genitals or other private
          body parts to a staff member or other person; or (2) engaging in acts
          of masturbation or any manual stimulation of one's exposed or
          unexposed genitals in a public setting, or in the view of a staff
          member or other person. A conviction of this charge will result in a
          loss of the inmate's visitation privileges for one (1) year.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>855 Smuggling and/or Conspiracy to Smuggle in Contraband: </b>Any
          inmate found to have conspired, aided, or acted in collusion with any
          person, or acting alone with the intent of introducing any form of
          contraband into any SCDC facility. Conspiracy, aid, or collusion may
          be defined as using any form of communication or providing any type of
          assistance with/to any person where plans are made with the intent of
          introducing contraband. The physical possession/receipt of the
          contraband by the inmate is not needed to support this charge. An
          inmate can be charged with this offense if his/her approved visitor is
          caught bringing in contraband and it is reasonable to believe that the
          visitor's intent was to supply the inmate with the contraband.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            858<b></b>&nbsp;{" "}
            <b>
              The Use or Possession of Practice GED Cheat Sheet, the Official
              GED Test, Any other Standardized or Educational Test, or
              Standardized Educational Materials Not Authorized for Use by the
              Inmate:
            </b>
          </b>{" "}
          Possession of, attempt to use, or provide others with a cheat sheet
          and/or answers to the GED questions, or other educational materials
          with the intention to gain unfair advantage in securing a passing
          score on the Practice GED Test<b>,</b> the Official GED Test, or any
          educational test administered or overseen by the Palmetto Unified
          School District. (NOTE: Any inmate convicted of this offense will also
          be prohibited from taking the GED Test while incarcerated.)
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            895 Inmate ID Card Violations: The following are violations of this
            infraction:&nbsp;
          </b>
          <ul style={{ marginLeft: "40px" }}>
            <li> To have possession of another inmate's ID card; </li>
            <li>
              {" "}
              To give another inmate possession of your ID card, or another
              inmate's ID card;
            </li>
            <li>
              To give your ID card to anyone not authorized to have possession
              of your ID card;
            </li>
            <li>The forgery of ID cards;</li>
            <li>
              {" "}
              Any other actions or use of an ID card that is inconsistent with
              the ID card's purpose.
            </li>
          </ul>
        </p>
        <br />
        <h5 className="text-xl text-center p-2 text-orange-primary underline">
          Level 3 Offenses
        </h5>
        <br />
        <p style={{ textAlign: "justify" }}>
          <b>815&nbsp; Evading a Security Device: </b>The act of an inmate to
          obstruct, tamper with, or jam any opening, closing, or exiting of a
          cell door, food flap, locks, any restraint devices, and/or secured
          area(s).
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>816&nbsp; Trafficking and Trading:</b>
          The buying or selling or unauthorized exchange of any commodity from
          any individual within the institution, other than authorized purchases
          from the canteen (evidence may include an excessive inventory of
          marketable items).&nbsp;
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>817&nbsp; Possession of Contraband: </b>&nbsp; The possession of
          any unauthorized, altered or excessive property, including money,
          tobacco products, gambling paraphernalia, unauthorized publications
          and unauthorized clothing. The possession of tobacco in a quantity
          larger than 40 grams is enough to reasonably assume that the intent of
          the possession was for distribution to other inmates and can be heard
          as a major disciplinary. Unauthorized property is any item to include
          keys not assigned to the inmate by the Department or purchased by the
          inmate from the canteen.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            818&nbsp; Use of Obscene, Vulgar or Profane Language or Gestures:{" "}
          </b>{" "}
          The act of any inmate who verbalizes or writes lewd or indecent notes
          or letters to another person, or makes gestures or actions that are
          discourteous or disrespectful in nature, when the person who receives
          verbal statements, notes, letters, gestures, or actions complains of
          such.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>819&nbsp; Stealing: </b>Intentionally taking any property belonging
          to a government agency, a private citizen, the State, an employee, or
          another inmate.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>821&nbsp; Gambling and Loan Sharking: </b>
          Any inmate who bets, lends, offers to lend, borrows or attempts to
          borrow anything of value from another person, or organizes the outcome
          of any event, including sporting contests. The possession of gambling
          paraphernalia may be sufficient evidence.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>823&nbsp; Fighting Without a Weapon: </b> Any group of two or more
          inmates who engage in a physical altercation.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            824&nbsp; Threatening to Inflict Harm, Physical or
            Otherwise/Assault, on Another Inmate:{" "}
          </b>
          &nbsp; The communication, verbal or written, by an inmate to another
          inmate that s/he intends to injure or commit a violent act, dangerous
          to human life, presently or in the future; or commits a physical act
          of a threatening nature placing another inmate in fear of bodily
          injury, causing evacuation or serious disruption.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>825&nbsp; Refusing or Failing to Obey Orders: </b>&nbsp;
          Noncompliance with a legitimate order from an SCDC employee or other
          government/contracted employee who is in a position of authority over
          the inmate. This includes resisting arrest or failure to follow
          written policy/procedure requirement (i.e., grooming standards,
          etc.).&nbsp; The act of any inmate whose actions interfere with or
          tends to interfere with anyone in pursuit of their assigned duties.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>826&nbsp; Refusing to Work: </b>Refusing to begin or complete a
          work assignment without a legitimate reason, such as illness.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            827&nbsp; Refusing to Attend the Compulsory (Mandatory) Program:{" "}
          </b>{" "}
          The refusal of any inmate who scores below an eighth grade reading or
          math level to enroll/attend/participate in school and/or the refusal
          of any inmate to attend or participate in any compulsory (mandatory)
          program.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>828&nbsp; Out of Place: </b> The act of an inmate who without
          authority either fails to report to his/her appointed place of duty or
          assignment or any other place to which he/she was ordered; leaves his
          or her appointed place of duty or assignment; is found to be in an
          unauthorized area; or does not have specific approval to be in an
          unauthorized area of the institution.&nbsp;&nbsp;
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>829&nbsp; Failure to Work: </b>Failure to complete a reasonable
          amount of an inmate's work assignment within a reasonable period of
          time, or sleeping on the job.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>830&nbsp; Mutiny: </b>When two (2) or more inmates conspire and
          refuse, as a group, to work, move, return to their cells or cubes,
          and/or create a work stoppage or other similar activity.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>831</b>&nbsp;&nbsp;{" "}
          <b>Lying to an Employee or Knowingly Making False Statements:</b> The
          intentional making of untrue statements by any inmate who makes a
          false statement under oath, makes inconsistent statements which are
          false, or makes a false statement to or against an employee or
          anyone.&nbsp; The act of any inmate who gives an untrue statement
          deliberately or a false impression to any SCDC employee, contracted
          employee or to an employee of a government agency which has authority
          in supervising the inmate.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>833&nbsp;</b>{" "}
          <b>
            Abusive Treatment of an Animal, Including Carnal Relations With an
            Animal:{" "}
          </b>{" "}
          Any physical maltreatment or improper misuse of an animal and/or
          engaging in sexual activities with an animal.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>834&nbsp;</b>{" "}
          <b>
            Any Act Defined as a Misdemeanor by the Laws of the State of South
            Carolina or the United States Not Otherwise Defined in these Rules:
            (State criminal statute must be provided)
          </b>
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>835</b> <b>Forgery or Possession of Any Forged Document:</b> The
          act with intent to defraud or deceive another person by falsely
          making, completing, or altering any document; or knowingly issuing or
          possessing such an instrument.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>836&nbsp;</b> <b>Disrespect: </b>
          The failure of any inmate to observe proper decorum or who willfully
          engages in action or make statements to a person which are
          discourteous in nature, which may or may not include the use of
          profanity.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>837&nbsp; Interfering with Count:</b>&nbsp; Failure to stand for
          count, movement during count which may create confusion or distraction
          of any kind, or activity by any inmate which may disrupt concentration
          or the orderly counting of inmates:
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            838&nbsp; Soliciting Improper Relationships:&nbsp; Assistance from
            an Employee or an Inmate to Violate an Agency Rule or an Employee
            Rule:
          </b>
          &nbsp; The act of any inmate who willfully induces any person to do or
          agree to do any act in violation of his/her lawful duty or in
          violation of SCDC rules and regulations, or in violation of the lawful
          rules and regulations of a government agency which is exercising
          legitimate authority over an inmate.&nbsp;&nbsp; Assisting in the
          Corruption of or Entering into an Improper Relationship with an
          Employee: The act of any inmate who willfully gives, offers or
          promises anything of value with the intent to influence any official
          act or action within the official responsibility of any employee; the
          act of any inmate who enters into an improper relationship with an
          employee.&nbsp; &nbsp; Soliciting Money or Gifts from a SCDC Employee
          or an Inmate, or from Another Person For the Benefit of an Inmate: Any
          inmate who tries to obtain, buy, or entice money or gifts from any
          SCDC employee or another person for his/her benefit.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            853 The unauthorized use of an inmate's telephone personal
            identification number(PIN).
          </b>{" "}
          The unauthorized use of telephone personal identification number is a
          serious violation. Inmate are prohibited from sharing and using other
          inmate's telephone PINs.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            856 Damage, Loss, Destruction, or Defacing of Property Valued at
            Less than $100.00:
          </b>{" "}
          The intentional or reckless damaging, destroying, or disfiguring
          property belonging to a government agency, a private citizen, an
          employee, or another inmate. Possession of damaged, destroyed, or
          disfigured property and the negligent loss of property also qualify as
          a violation of this offense. (NOTE: this does not include cases in
          which an inmate looses his/her ID card or issued room key. In these
          cases the inmate will be required to pay a replacement fee for such
          items and will not be processed pursuant to these procedures.) For
          further information regarding the processing of replacement fees, see
          SCDC Policies/Procedures OP-21.06, "Inmate Identification Cards," and
          OP-22.17, "Key Control."
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>859 Disorderly Conduct: </b>Any inmate who engages in any action
          which disrupts, or may lead to the disruption of the orderly
          operations of the institution.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            899 The Use, Possession, or Distilling and/or Brewing of any
            Alcoholic Beverage:
          </b>
          &nbsp; Any inmate acting under the influence of alcohol or in
          possession of alcohol or alcoholic beverage or other brewed substance
          which, when ingested, creates altered states of physical or mental
          activity.&nbsp; <b>Note:&nbsp;</b>The first two infractions of 899 for
          any inmate may be resolved Informally or Administratively by the
          Major/Responsible Authority.&nbsp; The third or subsequent infractions
          of 899 by an inmate must be referred to a hearing officer.&nbsp;
          However, regardless of how many times the inmate has committed this
          infraction, any large quantities of alcohol, or possession of alcohol
          which is commercially produced, or behavior which endangers the
          security and good order of the institution should be referred for a
          disciplinary hearing and Hearing Officers will consider such evidence
          when determining the severity of the sanctions imposed (i.e. large
          quantities of alcohol, multiple offenses, commercial alcohol, and
          endangering the security and good order of the institution, refusing
          to submit to alcohol testing, etc., will result in more severe
          sanctions).&nbsp; As always, the circumstances of the infraction and
          the inmate's disciplinary history should be taken into
          consideration.&nbsp;&nbsp; Questions should be addressed to the
          Division of Operations.&nbsp;&nbsp; &nbsp;
        </p>
        <br />
        <h5 className="text-xl text-center p-2 text-orange-primary underline">
          Level 4 Offenses
        </h5>
        <br />
        <p style={{ textAlign: "justify" }}>
          <b>839 Mutilation: </b>Physical injury to an inmate's body that is
          self-inflicted, allowing it to be inflicted by others with the
          inmate's permission, or assisting another inmate in mutilating
          himself/herself. (NOTE: Any inmate who pierces or attempts to pierce
          any part of his/her body, or assists others in piercing or attempting
          to pierce any part of their body will be charged with this offense as
          the practice creates a health and safety risk.)
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            840&nbsp; Failing or Refusing to Respond to an Employee's
            Questions:&nbsp;{" "}
          </b>
          The failure of any inmate to respond to any SCDC employee question
          even if it is felt that the question is unjust. It is not a defense
          that an inmate considers the question invalid.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>841&nbsp; Malingering </b>&nbsp; Pretending to be ill, or refusing
          to take their medication in order to avoid duty, school, to gain
          financial compensation, or undisclosed reasons involving secondary
          gain in order to manipulate the medical, mental health, security or
          other staff for the inmate's own benefit.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>842</b> <b>Use or Possession of Tattooing Paraphernalia:</b>&nbsp;
          The actual or constructive possession by an inmate of a tattooing
          device or a tattoo magazine, which may be used for the purpose of
          tattooing.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>843 Refusing Medical Treatment for a Communicable Disease: </b> The
          failure or refusal of medical treatment by any inmate with a disease
          capable of being transmitted. (<b>NOTE</b>: In these cases, inmates
          will be placed in medical isolation and will not be placed in PHD,
          Disciplinary Detention, or security detention status.)
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>844&nbsp; Interfering with the Duties of any Person </b>&nbsp; The
          act of any inmate whose actions interfere with anyone in pursuit of
          their assigned duties.
        </p>
        <br />
        <h5 className="text-xl text-center p-2 text-orange-primary underline">
          Level 5 Offenses
        </h5>
        <br />
        <p style={{ textAlign: "justify" }}>
          <b>601 Court Order Credit Loss: Pursuant to &sect;24-27-200,</b> a
          prisoner shall forfeit all or part of his earned work, education, or
          good conduct credits in an amount to be determined by the Department
          of Corrections upon recommendation of the court or administrative
          judge. Pursuant to South Carolina Supreme Court Opinion # 25409, filed
          02/11/2002 (also known as the Wade Decision). A forfeiture of earned
          credits pursuant to South Carolina Statute &sect;24-27-2000 cannot be
          as result of a post conviction relief hearing decision.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>845 Unauthorized Services/Piddling (Handicrafts):</b>&nbsp;&nbsp;
          No inmate shall provide or attempt to provide professional services or
          handicrafts for any person for any reason whether it is for profit or
          not.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>846 Creating Unnecessary Noise:</b>&nbsp; The act of any inmate who
          engages in any action which disrupts or may lead to the disruption of
          the orderly operation of the institution, the yelling/banging or
          excessive noise level by any inmate.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>847&nbsp;</b> <b>Abuse of Privileges:</b> The willful violation by
          an inmate of any provision of an institutional regulation dealing with
          a privilege. A privilege as used in this subsection is any benefit
          provided by institutional, SCDC, contracted services, or another
          governmental agency's regulations.
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>848 Exerting Any Authority Over Another Inmate, to Include:</b>
          <ol type="a" style={{ marginLeft: "40px" }}>
            <li>
              Administering any punishment or other form of discipline to other
              inmates;
            </li>
            <li>
              Granting or denying another inmate access to any benefit or
              activity;
            </li>
            <li>Controlling the movement or activities of other inmates;</li>
            <li>
              Escorting another inmate from one place to another, without a
              staff member, except as required by a bona fide emergency;
            </li>
            <li>
              Inventorying, with or without a staff member, another inmate's
              property or searching another inmate, his/her living area, or
              his/her property;
            </li>
            <li>Mailing or distributing another inmate's correspondence;</li>
            <li>Participating in the taking of any count; and</li>
            <li>
              Enforcing any SCDC or institutional or other governmental agency
              rule or regulation.
            </li>
          </ol>
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>849&nbsp; Disregarding Safety Regulations, to Include:</b>
          <ol type="a" style={{ marginLeft: "40px" }}>
            <li>
              Failing to wear safety goggles when performing any grinding,
              chiseling, filing, chipping, or buffing operation;
            </li>
            <li>
              Failing to wear hearing protection on any work station designated
              as a high noise level area or failing to wear work or safety shoes
              when instructed;
            </li>
            <li>
              Continuing to work in an area or on any machinery or equipment
              that is deemed unsafe or improperly guarded by the work
              supervisor;
            </li>
            <li>
              Operating machines or equipment or performing any operation that
              has not been specifically assigned;
            </li>
            <li>
              Operating equipment without using the safety guards provided or
              removing the safety guards;
            </li>
            <li>
              Unauthorized fabricating or repairing of personal items on
              government agency equipment;
            </li>
            <li>Riding on the draw bars of farm vehicles;</li>
            <li>
              Standing up while riding in moving vehicles or allowing legs to
              hang over sides of trailers while moving;
            </li>
            <li>
              Creating a health and/or safety hazard (to include flooding of
              cells).
            </li>
          </ol>
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>
            850 Violation of a Written or Posted Institutional Rule Not
            Contained in These Rules, But Consistent with These Rules:{" "}
          </b>
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>851&nbsp; Supervised Furlough II Violation: </b> Any inmate who is
          returned to the custody of the SCDC due to a violation of the
          Supervised Furlough Program. S/he will fail to earn any good time for
          the month s/he is returned to the custody of SCDC (automatic
          forfeiture). (NOTE: For further clarification, refer to SCDC
          Policy/Procedure OP-21.11, &quot;Loss of Statutory Good Time.&quot;)
        </p>
        <div style={{ clear: "both" }}></div>
      </div>
    </div>
  );
}
